/** Classes and per-pupil module assignment (tenant_admin only). */
import { request } from "./http";

export interface SchoolClass {
  id: string;
  name: string;
  member_ids: string[];
  module_codes: string[];
}

export interface LearnerAccess {
  user_id: string;
  direct_modules: string[];
  effective_modules: string[];
}

export function listClasses(): Promise<SchoolClass[]> {
  return request("/classes");
}

export function createClass(name: string): Promise<SchoolClass> {
  return request("/classes", { method: "POST", body: { name } });
}

export function deleteClass(id: string): Promise<void> {
  return request(`/classes/${id}`, { method: "DELETE" });
}

export function setClassMembers(id: string, userIds: string[]): Promise<SchoolClass> {
  return request(`/classes/${id}/members`, { method: "PUT", body: { user_ids: userIds } });
}

export function setClassModules(id: string, codes: string[]): Promise<SchoolClass> {
  return request(`/classes/${id}/modules`, { method: "PUT", body: { module_codes: codes } });
}

export function getLearnerAccess(userId: string): Promise<LearnerAccess> {
  return request(`/classes/learners/${userId}`);
}

export function setLearnerModules(userId: string, codes: string[]): Promise<LearnerAccess> {
  return request(`/classes/learners/${userId}`, {
    method: "PUT",
    body: { module_codes: codes },
  });
}

/** The content modules this school owns — all an admin may hand out. */
export function assignableModules(): Promise<string[]> {
  return request("/classes/assignable-modules");
}

/** "content.a2.practice" → "A2 Practice" for the checkbox labels. */
export function moduleLabel(code: string): string {
  const m = /^content\.([a-z][0-9])\.(learn|practice)$/.exec(code);
  if (!m) return code;
  return `${m[1].toUpperCase()} ${m[2] === "learn" ? "Course" : "Practice"}`;
}
